import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { ShoppingCartService } from 'src/app/gamification/marketplace/agent-side/services/shopping-cart.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import OverlayScrollbars from 'overlayscrollbars';

@Component({
  selector: 'cv-marketplace-filter',
  templateUrl: './cv-marketplace-filter.component.html',
  styleUrls: ['./cv-marketplace-filter.component.scss']
})
export class CvMarketplaceFilterComponent implements OnInit {

  @Input() textFilter: string;
  @Output() sortFunction = new EventEmitter<any>();
  @Output() updateSelectedTags = new EventEmitter<any>();
  @Output() clearSearch = new EventEmitter<string>();

  pscs: any = null;
  expanded: boolean[] = [];
  isOnSaleChecked: boolean = false;
  isBestSellerChecked: boolean = false;
  subCategoriesFilterChecked: any = [];
  filterMatchProduct: string = '';
  selectedCategory: string = '';
  filters: string[] = [];
  selectedCategories: any[] = [];
  translatedOnSale: string ='';
  translatedBestSeller: string = '';
  categoryCollectionArray: any = [];

  isCxone: boolean = false;
  localizationStrings = new Map();

  constructor(
    private shoppingCartService: ShoppingCartService,
    private cvConfigurationService: CvConfigurationService,
    private cvLocalizationService: CVLocalizationService,
  ) {
    this.pscs = shoppingCartService.shoppingCartObj;
    this.isCxone = cvConfigurationService.isCxOne;
  }

  async ngOnInit(): Promise<void>{
    this.clearAll();
    await this.loadLocalizations();
    this.translatedOnSale = this.getLocalizationString('On_Sale', 'On Sale');
    this.translatedBestSeller = this.getLocalizationString('Best_Sellers_Capitalized', 'Best Seller');
    this.categoryCollectionArray = Object.assign([], this.pscs.categoryCollectionArray);

    //Commented out in case we need to remember previous filters applied in the future.
    // setTimeout(() => {
    //   this.setFilters();
    // }, 0);

  }

  // setFilters() {
  //   if (this.pscs.shoppingCartProducts != null && this.pscs.shoppingCartProducts.length > 0) {
  //     this.isOnSaleChecked = this.pscs.shoppingCartOptions.onSaleFilterChecked;
  //     this.isBestSellerChecked = this.pscs.shoppingCartOptions.bestSellerFilterChecked;
  //     this.filters = this.pscs.ShoppingCartActiveFilters;
  //     if (this.pscs.shoppingCartCategoryFilter != '') {
  //       this.selectedCategory = this.pscs.shoppingCartCategoryFilter;
  //       this.pscs.categoryCollectionArray.forEach((category, index) => {
  //         if (category.name == this.selectedCategory) {
  //           this.expanded[index] = true;
  //         }
  //       });
  //     }
  //     else {
  //       this.selectedCategory = 'ALL';
  //       this.pscs.shoppingCartCategoryFilter = this.selectedCategory;
  //     }
  //     if (this.pscs.shoppingCartActivecategoriesFitler) {
  //       this.selectedCategories = this.pscs.shoppingCartActivecategoriesFitler;
  //       this.selectedCategories.forEach(categoryFilters => {
  //         setTimeout(() => {
  //           let input: any = document.getElementById(categoryFilters.Category + '_' + categoryFilters.Subcategory);
  //           if (input != null)
  //             input.checked = true;
  //         }, 0);
  //       });
  //     }
  //   }
  //   else {
  //     setTimeout(() => {
  //       this.setFilters();
  //     }, 500);
  //   }
  // }
  filterScrollOptions: OverlayScrollbars.PartialOptions = {
    scrollbars: {
      visibility: 'visible',
      autoHide: "leave",
      autoHideDelay: 100,
      theme: "custom-scrollbar"
    },
    overflow: {
      x: 'hidden',
      y: 'scroll'
    },
  };
  setCategory(category) {
    this.selectedCategory = category;
    this.pscs.shoppingCartCategoryFilter = this.selectedCategory;
    this.updateSelectedTags.emit({ event: event, filter: 'category', action: 'remove' });
  }
  async loadLocalizations(): Promise<void> {
    this.localizationStrings = await this.cvLocalizationService.GetSection("MarketPlace");
  }

  getLocalizationString(key, defaultValue) {
    if (this.localizationStrings && this.localizationStrings.has(key))
      return this.localizationStrings.get(key);
    return defaultValue;
  }
  updateFilters(filter) {
    let clearAllBtn = document.getElementById("clear-all-categories");
    if (clearAllBtn != null)
      clearAllBtn.style.visibility = "hidden";
    let variableFilter = "";
    switch (filter) {
      case this.translatedOnSale:
        variableFilter = "OnSale"
        break;

      case this.translatedBestSeller:
        variableFilter = "BestSeller"
        break;
      default:
        variableFilter = filter;
        break;
    }
    if (variableFilter === "BestSeller" ||variableFilter ===  "OnSale") {
      let index = this.filters.indexOf(variableFilter);
      if (index > -1) {
        this.filters.splice(index, 1);
        if (index > -1) {
          this.updateSelectedTags.emit({ event: event, filter: variableFilter == 'OnSale' ? this.translatedOnSale : this.translatedBestSeller, action: 'remove' });
        }
      }
      if (filter == this.translatedOnSale) {
        this.isOnSaleChecked = false;
        this.pscs.shoppingCartOptions.onSaleFilterChecked = false;
      }
      else {
        this.isBestSellerChecked = false;
        this.pscs.shoppingCartOptions.bestSellerFilterChecked = false;
      }
    }
    else {
      let index = this.selectedCategories.map(c => c.Subcategory).indexOf(filter);
      if (index > -1) {
        this.selectedCategories.splice(index, 1);
      }
      if (this.selectedCategories.length == 0) {
        let filterIndex = this.filters.indexOf('SubCategory');
        if (filterIndex > -1) {
          this.filters.splice(filterIndex, 1);
        }
        this.filters.push('Category');
      }
      let input: any = document.getElementById(this.selectedCategory + '_' + filter);
      if (input != undefined)
        input.checked = false;
    }
    this.shoppingCartService.filterShoppingCartProduct(this.filters, this.selectedCategory, this.selectedCategories, true);
    setTimeout(() => {
      let tagContainer: any = document.getElementsByClassName("cxone-tags")[0];
      if (tagContainer != null) {
        let width = tagContainer.offsetWidth
        let clearAllBtn = document.getElementById("clear-all-categories");
        if (clearAllBtn != null)
          clearAllBtn.style.visibility = "visible";
      }
    }, 10)
  }

  applyFilter(filterType, event = null) {
    this.clearSearch.emit();
    if (event != null) {
      if (event.target.tagName.toUpperCase() != "INPUT") {
        return;
      }
      let isInputChecked = jQuery(event.target).is(":checked");
      if (filterType == 'OnSale')
        this.pscs.shoppingCartOptions.onSaleFilterChecked = isInputChecked;
      else
        this.pscs.shoppingCartOptions.bestSellerFilterChecked = isInputChecked;

      if (isInputChecked) {
        this.filters.push(filterType);
        this.updateSelectedTags.emit({ event: event, filter: filterType == 'OnSale' ? this.translatedOnSale : this.translatedBestSeller, action: 'add' });
      } else {
        let index = this.filters.indexOf(filterType);
        if (index > -1) {
          this.filters.splice(index, 1);
          if (index > -1) {
            this.updateSelectedTags.emit({ event: event, filter: filterType == 'OnSale' ? this.translatedOnSale : this.translatedBestSeller, action: 'remove' });
          }
        }
      }
      this.shoppingCartService.filterShoppingCartProduct(this.filters, this.selectedCategory, this.selectedCategories, true);
    }
  }

  applySubCategoriesFilter(category, subcategory, event) {
    this.clearSearch.emit();
    if (event != null) {
      if (event.target.tagName.toUpperCase() != "INPUT") {
        return;
      }
      let filterIndex = this.filters.indexOf('Category');
      if (filterIndex > -1) {
        this.filters.splice(filterIndex, 1);
      }
      let isInputChecked = jQuery(event.target).is(":checked");
      if (isInputChecked) {
        this.selectedCategories.push({ Id: String(category) + String(subcategory), Category: category, Subcategory: subcategory });
        this.updateSelectedTags.emit({ event: event, filter: subcategory, action: 'add' });
        let filterIndex = this.filters.indexOf('SubCategory');
        if (filterIndex === -1) {
          this.filters.push('SubCategory');
        }
      } else {
        let index = this.selectedCategories.map(c => c.Id).indexOf(String(category) + String(subcategory));
        if (index > -1) {
          this.selectedCategories.splice(index, 1);
          this.updateSelectedTags.emit({ event: event, filter: subcategory, action: 'remove' });
        }
        if (this.selectedCategories.length == 0) {
          let filterIndex = this.filters.indexOf('SubCategory');
          if (filterIndex > -1) {
            this.filters.splice(filterIndex, 1);
          }
          this.filters.push('Category');
        }
      }
      this.shoppingCartService.filterShoppingCartProduct(this.filters, category, this.selectedCategories, true);
      this.sortFunction.emit();
    }
  }

  applyCategoryFilter(category) {
    this.clearSearch.emit();
    this.selectedCategories = [];
    if (this.selectedCategory == category) {
      let filterIndex = this.filters.indexOf('SubCategory');
      if (filterIndex > -1) {
        this.filters.splice(filterIndex, 1);
      }
    }

    let filterIndex = this.filters.indexOf('Category');
    if (filterIndex == -1) {
      this.filters.push('Category');
    }

    this.shoppingCartService.filterShoppingCartProduct(this.filters, category, this.selectedCategories, true);
  }

  clearAll(event = null) {
    this.selectedCategory = 'ALL'
    this.pscs.shoppingCartCategoryFilter = 'ALL';
    this.isOnSaleChecked = false;
    this.pscs.shoppingCartOptions.onSaleFilterChecked = false;
    this.isBestSellerChecked = false;
    this.pscs.shoppingCartOptions.bestSellerFilterChecked = false;
    for (let i = 0; i < this.expanded.length; i++) this.expanded[i] = false;
    this.filters = [];
    this.pscs.ShoppingCartActiveFilters = [];
    this.selectedCategories = [];
    this.pscs.shoppingCartActivecategoriesFitler = [];
    this.updateSelectedTags.emit({ event: event, filter: 'all', action: 'remove' });
    this.shoppingCartService.clearShoppingCartProductFilters();
  }

  setAllFilter() {
    this.selectedCategories.forEach(selectedCategory => {
      let index = this.selectedCategories.map(c => c.Id).indexOf(String(this.selectedCategory) + String(selectedCategory.Subcategory));
      if (index > -1) {
        this.updateSelectedTags.emit({ event: event, filter: selectedCategory.Subcategory, action: 'remove' });
      }
    });

    this.selectedCategories = [];
    let filterIndex;
    this.selectedCategory = "ALL";
    this.pscs.shoppingCartCategoryFilter = this.selectedCategory;

    for (let i = 0; i < this.expanded.length; i++) this.expanded[i] = false;
    this.filters.forEach(filterOpt => {
      if (filterOpt == "Category") {
        filterIndex = this.filters.indexOf('Category');
        if (filterIndex > -1) {
          this.filters.splice(filterIndex, 1);
        }
      }
      if (filterOpt == "SubCategory") {
        filterIndex = this.filters.indexOf('SubCategory');
        if (filterIndex > -1) {
          this.filters.splice(filterIndex, 1);
        }
      }
    });

    this.shoppingCartService.filterShoppingCartProduct(this.filters, '', this.selectedCategories, true);
  }

  isCurrentSale(item): any {
    if (typeof item !== 'undefined') {
      return this.shoppingCartService.filterCollectionsByType(item, 1);
    }
  }

  hasManyProductsByFilter(category): any {
    return this.shoppingCartService.countDisplayCategoriesBySearch(category);
  }

  showSubCategories(index) {
    let i = 0;
    this.subCategoriesFilterChecked = [];
    if (this.expanded[index]) {
      this.expanded[index] = false;
    } else {
      for (i; i < (this.expanded.length); i++) {
        this.expanded[i] = false;
      }
      this.expanded[index] = true;
    }
  }

  hasManyProducts(category): any {
    let quantityCount = 0;
    let isCategoryALL = category == 'ALL';
    if (this.pscs.shoppingCartProducts != null && this.pscs.shoppingCartProducts.length > 0) {
      this.pscs.shoppingCartProducts.forEach((product) => {
        if (isCategoryALL) category = product.Category;
        if (this.isOnSaleChecked && this.isBestSellerChecked) {
          if (product.Category == category && this.isCurrentSale(product) && product.isBestSeller) quantityCount = quantityCount + 1;
        } else if (this.isOnSaleChecked) {
          if (product.Category == category && this.isCurrentSale(product)) quantityCount = quantityCount + 1;
        } else if (this.isBestSellerChecked) {
          if (product.Category == category && product.isBestSeller) quantityCount = quantityCount + 1;
        } else {
          if (product.Category == category) quantityCount = quantityCount + 1;
        }
      });
    }
    return quantityCount;
  }

  getVisibleProductsCount() {
    let count = 0;
    if (this.pscs.shoppingCartProducts != null) {
      this.pscs.shoppingCartProducts.forEach(product => {
        if (product.showItem)
          count++;
      });
    }
    return count;
  }

}
